<span role="timer">{{ time / 1000 | coreSecondsToHMS:hours }}</span>
